<template>
  <div>
    <cooperation-search-head
      :titleInfo="titleInfo"
      :bgUrl="bgUrl"
      @handSearch="handSearch"
      :companyList="companyList"
      :showDropSelect="true"
    >
    </cooperation-search-head>
    <div class="cooperation-report-index-container">
      <div class="report-content-head">
        <cooperation-title-cp
          title="产值概览"
          :bg="false"
        ></cooperation-title-cp>
        <div class="report-title">
          <div class="left">
            <p>
              累计申报产值： <span>{{ body.adApplyamount | money2 }}</span>
            </p>
            <p>
              累计审定金额： <span>{{ body.adApproveamount | money2 }}</span>
            </p>
            <p>
              累计应付进度款： <span>{{ body.adScheduleamount | money2 }}</span>
            </p>
          </div>
          <div class="right">
            <p>
              本月申报金额： <span>{{ body.cmApplyamount | money2 }}</span>
            </p>
            <p>
              本月审定金额： <span>{{ body.cmApproveamount | money2 }}</span>
            </p>
            <p>
              本月应付进度款： <span>{{ body.cmScheduleamount | money2 }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="report-body-content">
        <cooperation-title-cp
          title="我的产值申报"
          :bg="false"
        ></cooperation-title-cp>
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <div class="mine-item">
                <mine-report-change :item="item"></mine-report-change>
                <div class="mine-item-bg"></div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import cooperationTitleCp from '../components/title-cp';
import mineReportChange from './cooperation-packge/components/cooperation-my-report-change-cp';
import cooperationSearchHead from './cooperation-packge/components/cooperation-search-head-cp';

import { List, PullRefresh, Sticky } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-report-index',

  data() {
    return {
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      body: {},
      companyList: [],
      params: {},
      titleInfo: {
        selectname: '申报日期',
        selectTitle: '申报日期'
      },
      bgUrl: '',
      filterUserCenterUserInfo: {
        employeeName: '测试',
        mobile: '15828097809'
      },
      watertext: '',
      watermobile: ''
    };
  },
  mounted() {},
  created() {
    let { providerGuid, employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    let params = {
      providerGuid,
      current: this.current,
      size: this.size
    };
    this.providerGuid = providerGuid;
    this.getApplyStatistics(params);

    this.getApplyInfo(params);
    this._getComplay({ type: 'outputApply' });
    this.$api.getBannerList({ current: 1, size: 999 }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        let { records } = body;
        records = records.filter(item => item.position == 4);
        this.bgUrl = records.length && records[0].image;
      }
    });
  },
  components: {
    cooperationTitleCp,
    mineReportChange,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        });
    },
    getUrlParams() {
      let url = window.location.href.split('?')[1];
      let obj = {};
      if (url.indexOf('&') > -1) {
        url = url.split('&');
        for (let i = 0; i < url.length; i++) {
          let arr = url[i].split('=');
          obj[arr[0]] = arr[1];
        }
      } else {
        url = url.split('=');
        obj[url[0]] = url[1];
      }
      return obj;
    },
    getApplyStatistics(params) {
      this.$api.getApplyStatistics(params).then(res => {
        let { body } = res;
        if (res.status) {
          this.body = body;
        }
      });
    },
    getApplyInfo(params) {
      let { current, providerGuid, size } = this;
      params = { providerGuid, ...params, current, size };
      this.$api.getApplyInfo(params).then(res => {
        let { body } = res;
        let { records } = body;
        if (res.status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    handSearch(data) {
      let params = { ...data };
      this.list = [];
      this.current = 1;
      this.params = params;
      this.loading = false;
      this.finished = false;
      this.getApplyInfo(params);
    },
    onLoad() {
      this.current++;
      let { params } = this;
      this.getApplyInfo(params);
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-report-index-container {
  margin-top: 10px;
  position: relative;
  z-index: 9;
  .report-body-content {
    margin-top: 20px;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
    .van-cell:nth-child(1) {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      // background-color:transparent;
    }
    .mine-item {
      background: transparent;
      margin-top: 10px;
      .mine-item-bg {
        background: #efefef;
        height: 10px;
      }
    }
    .mine-item:nth-child(2) {
      margin-top: 0 !important;
    }
  }
  .report-content-head {
    .report-title {
      height: 160px;
      font-size: 24px;
      width: 100%;
      background: transparent;
      display: flex;
      padding: 30px;
      .left {
        width: 50%;
        height: 110px;
        border-right: 1px solid #efefef;
        // padding-right: 20px;
        // overflow: hidden;
        span {
          color: #000000;
          float: right;
          text-align: left;
          width: 150px;
        }
        p {
          margin-top: 15px;
          color: #666666;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
      .right {
        height: 110px;
        width: 50%;
        padding-left: 20px;
        // padding-right: 40px;
        // overflow: hidden;
        span {
          color: #c18858;
          text-align: left;
          width: 130px;
          float: right;
        }
        p {
          margin-top: 15px;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
